import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ImImportObjectBaseComponent} from "../im-import-object-base.component";

@Component({
    selector: 'im-import-object-side',
    templateUrl: './im-import-object-side.component.html',
    standalone: false
})
export class ImImportObjectSideComponent extends ImImportObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized


    ngOnInit(): void {
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
